import { SHARED_ROUTES } from '@aibees/shared/constants';
import { useSubscriptionExpiryInfo } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import { PLAN_EXPIRY_HIDDEN } from '../subscription-bar/constants';
import * as Styled from './styles';
import * as SX from './sx';
import type { PlanExpiredBarProps as Props } from './types';

export const PlanExpiredBar = memo(({ className }: Props) => {
  const { isExpired, isLoading } = useSubscriptionExpiryInfo();

  if (PLAN_EXPIRY_HIDDEN || isLoading || !isExpired) return null;

  const text = 'Your plan has expired.';
  const buttonText = 'Upgrade Plan';
  const to = SHARED_ROUTES.priceAndPlan;

  return (
    <Styled.Wrapper
      className={classnames('PlanExpiredBar', className)}
      sx={SX.root}
      icon={false}
    >
      <Typography variant="body2" fontWeight={600} sx={SX.text}>
        {text}
      </Typography>
      <Styled.Subscribe size="small" to={to}>
        <Typography variant="body3" fontWeight={600}>
          {buttonText}
        </Typography>
      </Styled.Subscribe>
    </Styled.Wrapper>
  );
});

PlanExpiredBar.displayName = 'PlanExpiredBar';
